import { Infobulle } from './Infobulle';

/**
 * L'icone « note » (2026-10-31) : un bloc-notes, a gauche du nom dans la
 * liste des adherents quand la fiche porte un commentaire. Meme recette
 * que les icones de contrat : SVG maison en 16 px, gris, et le contenu
 * de la note survit dans l'infobulle commune (2026-11-04) et dans
 * `aria-label`.
 */
export function IconeNote({ texte }: { texte: string }) {
  const libelle = `Note : ${texte}`;
  return (
    <Infobulle texte={texte} className="inline-flex">
      <svg
        viewBox="0 0 16 16"
        className="h-4 w-4 shrink-0 text-encre-500"
        role="img"
        aria-label={libelle}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="2" width="10" height="12.5" rx="1.5" />
        <path d="M5.5 1v2.5M8 1v2.5M10.5 1v2.5" />
        <path d="M5.5 7h5M5.5 9.5h5M5.5 12h3" />
      </svg>
    </Infobulle>
  );
}
